import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../utils/api';
import { toast } from 'sonner';

const KioskLogin = () => {
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [pin, setPin] = useState('');
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    if (!username.trim() || !pin.trim()) { toast.error('Enter username and PIN'); return; }
    setLoading(true);
    try {
      const { data } = await api.post('/kiosk/login', { username: username.trim(), pin: pin.trim() });
      sessionStorage.setItem('kiosk_session', JSON.stringify(data));
      toast.success(`Welcome! ${data.role === 'timekeeper' ? 'Timekeeper' : data.role === 'office' ? 'Office Staff' : 'Kiosk Entry'} for: ${data.show_name}`);
      if (data.role === 'timekeeper') navigate('/kiosk/timekeeper');
      else if (data.role === 'office') navigate('/kiosk/office');
      else navigate('/kiosk/enter');
    } catch (err) { toast.error(err.response?.data?.detail || 'Invalid username or PIN'); }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-[#0A0A0A] flex items-center justify-center px-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <img src="https://customer-assets.emergentagent.com/job_2decf1d9-6688-4b47-98c1-1893beae897a/artifacts/lr28yf8y_43425DE4-4AE4-4784-89F6-4AA746534747.png"
            alt="Show Master" className="h-20 w-20 mx-auto mb-4" />
          <h1 className="text-3xl font-black text-white" style={{fontFamily: 'Outfit'}}>Kiosk Entry</h1>
          <p className="text-[#9E9E9E] text-sm mt-1">Enter your kiosk credentials to start entering riders</p>
        </div>

        <form onSubmit={handleLogin} className="bg-[#161616] border border-[#262626] rounded-lg p-6 space-y-4">
          <div>
            <label className="block text-xs text-[#9E9E9E] mb-1">Username</label>
            <input type="text" value={username} onChange={(e) => setUsername(e.target.value)}
              placeholder="Kiosk username" autoFocus
              className="w-full px-4 py-3 bg-[#0A0A0A] border border-[#262626] rounded-md text-white text-lg focus:outline-none focus:border-[#0096FF]"
              data-testid="kiosk-username" />
          </div>
          <div>
            <label className="block text-xs text-[#9E9E9E] mb-1">PIN</label>
            <input type="password" value={pin} onChange={(e) => setPin(e.target.value)}
              placeholder="Enter PIN" inputMode="numeric"
              className="w-full px-4 py-3 bg-[#0A0A0A] border border-[#262626] rounded-md text-white text-lg tracking-[0.3em] focus:outline-none focus:border-[#0096FF]"
              data-testid="kiosk-pin" />
          </div>
          <button type="submit" disabled={loading}
            className="w-full py-3 bg-[#0096FF] hover:bg-[#00D4FF] text-white font-bold rounded-md text-lg transition-colors disabled:opacity-50"
            data-testid="kiosk-login-btn">
            {loading ? 'Signing in...' : 'Start Entering'}
          </button>
        </form>

        <p className="text-center text-[#525252] text-xs mt-6">
          Ask a show producer for your kiosk credentials
        </p>
      </div>
    </div>
  );
};

export default KioskLogin;
